import * as React from 'react';

import * as styles from './AboutActionsContainer.css';
import { FavoriteButtonContainer } from '../FavoriteButton';
import { COMPARISON_ENTRYPOINTS_ENABLED_CONFIG } from '../Comparison/constants';
import { NewbuildingCompareButton } from '../NewbuildingCompareButton';
import { useApplicationContext } from '../../utils/applicationContext';

export const AboutActionsContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const isComparisonEntrypointsEnabled = config.get<boolean>(COMPARISON_ENTRYPOINTS_ENABLED_CONFIG) || false;

  if (!isComparisonEntrypointsEnabled) {
    return null;
  }

  return (
    <div className={styles['actions']} data-testid="AboutActions">
      <FavoriteButtonContainer buttonTheme="stroke_primary" />
      <NewbuildingCompareButton buttonTheme="stroke_primary" addToCompareText="В сравнение" source="about_building" />
    </div>
  );
};
